export default __webpack_public_path__ + "static/media/dog-image-1.06a70aa4.jpg";